import { registerProjectRouteBackNavigation } from '~/entities/projects/model/registerProjectRouteBackNavigation'

export default defineNuxtPlugin(() => {
  registerProjectRouteBackNavigation()
})
